import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_StatGroup({ id, className, Items }) {
    const UI = useContext(Context_UI);

    return (
        <>
            {Items ?
                <div className={className ? `StatGroup ${className}` : "StatGroup"
                } id={id} >
                    {
                        Items.map((Item) => (
                            <>
                                {Item ?
                                    <div className="Card Stat" Color={Item?.Color}>
                                        {Item?.Key ? 
                                            <p className="Stat_Key">
                                                {Item?.Key}
                                            </p>
                                            :
                                            ""
                                        }
                                        {Item?.Value ?
                                            <p className="Stat_Value">
                                                {Item?.Value}
                                            </p>
                                            :
                                            ""
                                        }
                                    </div>
                                    :
                                    ""
                                }
                            </>

                        ))
                    }
                </div >
                :
                ""
            }

        </>


    )
}

